import script from "./LoadPortfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadPortfolio.vue?vue&type=script&setup=true&lang=js"

import "./LoadPortfolio.vue?vue&type=style&index=0&id=7288471c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7288471c"]])

export default __exports__